import apiUrl from "../../../utils/settings";


export const getHomepageDataUrl = () => {
    return apiUrl + '/home';
}

export const getDashboardConfigUrl = () => {
    return apiUrl + '/company/dashboard-config';
}